export default class AbstractBrickConfig {
  constructor(params) {
    this.apiKey = params.apiKey;
    this.authToken = params.authToken;
    this.campaign = params.campaign;
    this.brickType = params.brickType;
  }

  merge(otherBrickData) {
    this.apiKey = this.apiKey || otherBrickData.apiKey;
    this.authToken = this.authToken || otherBrickData.authToken;
    this.campaign = this.campaign || otherBrickData.campaign;
  }

  isValid() {
    return this.errors().length === 0;
  }

  errors() {
    const errorArray = [];

    if (!this.apiKey) {
      errorArray.push('apiKey cannot be null');
    }

    return errorArray;
  }

  setId(id) {
    this.id = id;
  }

  isIframe() {
    return this.buildWithIframe;
  }

  toQueryParamObject() {
    const queryParams = {};

    if (this.apiKey) queryParams.apiKey = this.apiKey;
    if (this.authToken) queryParams.authToken = this.authToken;
    if (this.campaign) queryParams.campaign = this.campaign;

    return queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/models/abstract-brick-config.js